module.exports = __webpack_public_path__ + "static/media/Bianco.e950f8a1.png";